import * as React from "react";
import { Grid, TextField } from "@mui/material";

export default function SmartLockTemporaryPasswordEditForm({ passwordName, handleChangePasswordName, errors}) {
  return (
    <Grid container component="form" noValidate autoComplete="off" spacing={2} sx={{ padding:"10px" }}>
      <Grid item xs={12} sm={12}>
        <TextField size="small" name="passwordName" fullWidth value={passwordName} onChange={handleChangePasswordName} helperText={errors.passwordName} error={Boolean(errors.passwordName)} label="Password Name" />
      </Grid>
    </Grid>
  );
}
